import moment from 'moment';
import { path, toLower } from 'ramda';
import { ERRORS } from 'constants/serverMessages';

export const getSaleDeleteErrorMessage = (action, fallback) => {
    const violation = path(['payload', 'data', 'errors', 'date', 0], action);
    if (!violation) {
        return fallback;
    }

    const template = ERRORS[toLower(violation.message_template || '')] || ERRORS[toLower(violation.message || '')];
    if (!template) {
        return fallback;
    }

    let message = template;
    const month = path(['attributes', '{month}'], violation);
    const date = path(['attributes', '{date}'], violation);

    if (month) {
        message = message.replace('"{month}"', moment(month).format('MMMM YYYY'));
    }

    if (date) {
        message = message.replace('"{date}"', moment(date).format('DD.MM.YYYY'));
    }

    return message;
};

export const checkError = (field, errorMsg) => ({ setFieldError, formAction: { meta: { error }}}) => {
    if (path(['data', 'errors', field, '0', 'message'], error) === errorMsg) {
        setFieldError(field, ERRORS[errorMsg]);
    }
};
